import { Component, EventEmitter, inject, Output }             from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, Validators } from '@angular/forms';
import { MatError, MatFormField, MatLabel }                    from '@angular/material/form-field';
import { MatInput }                                            from '@angular/material/input';
import { MatProgressSpinner }                                  from '@angular/material/progress-spinner';

import { asciiOnlyValidator }          from '../../../../../shared/validators/ascii-only.validator';
import { StringUtils }                 from '../../../../../shared/utils/string.utils';
import { AuthenticationService }       from '../../../../../core/auth/authentication.service';
import { ButtonComponent, ButtonType } from '../../../../../shared/components/buttons/button.component';
import { PinNotificationComponent }    from '../../../../../shared/components/notification/notification.component';
import { AutoFocusDirective }          from '../../../../../shared/directives/auto-focus.directive';

@Component({
  selector: 'pin-request-verification-code',
  templateUrl: './request-verification-code.component.html',
  imports: [PinNotificationComponent, ReactiveFormsModule, MatFormField, MatLabel, MatInput, AutoFocusDirective, MatError, ButtonComponent, MatProgressSpinner]
})
export class RequestVerificationCodeComponent {
  public showTooManyTriesNotification = false;
  @Output()
  forgotPasswordEventEmitter = new EventEmitter<string>();
  loading = false;
  protected readonly buttonType = ButtonType;

  private authService = inject(AuthenticationService);
  private formBuilder = inject(UntypedFormBuilder);

  public usernameForm = this.formBuilder.group({
    username: ['', [Validators.required, asciiOnlyValidator(StringUtils.USERNAME_ILLEGAL_CHARACTERS)]]
  });

  requestVerificationCode() {
    if (!this.usernameForm.valid || this.loading) {
      return;
    }
    const username = this.usernameForm.getRawValue()['username'];
    this.loading = true;
    this.authService.forgotPassword(username).subscribe({
      next: () => {
        this.forgotPasswordEventEmitter.emit(username);
      },
      error: error => {
        const errorMessage = typeof error?.error === 'string' ? error.error : error?.error?.message;
        if (errorMessage === 'ERR_LIMIT_EXCEEDED') {
          this.showTooManyTriesNotification = true;
          this.loading = false;
          window.scroll(0, 0);
        } else {
          this.forgotPasswordEventEmitter.emit(username);
        }
      }
    });
  }
}
